import { useCallback } from 'react';
import {
  setTasksModalData,
  setTasksModalVisible,
} from '../store/actions/calendarActions';
import { useCalendarDispatch } from '../context/CalendarContext';

const useMoreButtonClick = () => {
  const dispatch = useCalendarDispatch();

  const handleMoreButtonClick = useCallback(
    (data) => {
      dispatch(setTasksModalData(data));
      dispatch(setTasksModalVisible(true));
    },
    [dispatch]
  );

  return handleMoreButtonClick;
};

export default useMoreButtonClick;
